var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(!_vm.isLoggedIn)?_c('Login'):_vm._e(),_c('div',[_vm._v("Welcome to solar tester web site!")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }